import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Typography } from '@mui/material';

import LoaderContainer from './styles';

const Loader = props => {
  const {
    active = false,
    fullFilled = false,
    bg = '',
    text = '',
    position = 'absolute',
    zIndex = '',
  } = props;

  return (
    <>
      {active && (
        <LoaderContainer
          className="loader"
          $position={position}
          $fullFilled={fullFilled}
          $bg={bg}
          $zIndex={zIndex}
        >
          <CircularProgress />
          {text && <Typography className="loader__text">{text}</Typography>}
        </LoaderContainer>
      )}
    </>
  );
};

Loader.propTypes = {
  active: PropTypes.bool,
  fullFilled: PropTypes.bool,
  bg: PropTypes.string,
  text: PropTypes.string,
  position: PropTypes.string,
  zIndex: PropTypes.string,
};

export default React.memo(Loader);
